import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

const EMPTY = { plan_name: "", price: "", billing_cycle: "Monthly", next_payment: "", status: "upcoming" };
const STATUS_STYLE = {
  paid: "text-volt border-volt/50",
  upcoming: "text-zinc-300 border-zinc-600",
  overdue: "text-red-400 border-red-400/50",
};

export default function PaymentsTab() {
  const [members, setMembers] = useState([]);
  const [editFor, setEditFor] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/coach/members").then((r) => setMembers(r.data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const save = async (uid) => {
    await api.put(`/coach/members/${uid}/payment`, form);
    toast.success("Payment plan saved");
    setEditFor(null);
    load();
  };

  const overdue = members.filter((m) => m.payment?.status === "overdue").length;

  return (
    <div data-testid="coach-payments">
      <div className="flex items-end justify-between mb-6">
        <h2 className="font-display uppercase text-4xl">Payments</h2>
        {overdue > 0 && <span className="text-xs uppercase tracking-[0.16em] font-bold text-red-400" data-testid="payment-alerts">{overdue} overdue</span>}
      </div>
      <div className="border border-zinc-800 divide-y divide-zinc-800/70">
        {members.map((m) => (
          <div key={m.user_id} data-testid={`payment-row-${m.user_id}`} className="bg-zinc-950 p-5">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-bold text-zinc-100">{m.name}</p>
                <p className="text-xs text-zinc-500">{m.payment ? `${m.payment.plan_name} · ${m.payment.price} · ${m.payment.billing_cycle}` : "No plan set"}</p>
              </div>
              <div className="flex items-center gap-3">
                {m.payment && (
                  <span className={`text-[10px] uppercase tracking-[0.14em] font-extrabold border px-2.5 py-1 ${STATUS_STYLE[m.payment.status] || ""}`}>
                    {m.payment.status}
                  </span>
                )}
                <button data-testid={`payment-edit-${m.user_id}`}
                  onClick={() => { setEditFor(editFor === m.user_id ? null : m.user_id); setForm(m.payment || EMPTY); }}
                  className="text-xs uppercase tracking-[0.14em] font-bold text-zinc-400 hover:text-volt transition-colors">
                  {m.payment ? "Edit" : "Set plan"}
                </button>
              </div>
            </div>
            {editFor === m.user_id && (
              <div className="mt-4 grid sm:grid-cols-5 gap-2">
                <input placeholder="Plan name" value={form.plan_name} data-testid="pay-plan-name"
                  onChange={(e) => setForm({ ...form, plan_name: e.target.value })}
                  className="bg-ink border border-zinc-700 px-3 py-2.5 text-sm focus:border-volt outline-none" />
                <input placeholder="Price (e.g. ₹3,999)" value={form.price} data-testid="pay-price"
                  onChange={(e) => setForm({ ...form, price: e.target.value })}
                  className="bg-ink border border-zinc-700 px-3 py-2.5 text-sm focus:border-volt outline-none" />
                <input type="date" value={form.next_payment} data-testid="pay-next"
                  onChange={(e) => setForm({ ...form, next_payment: e.target.value })}
                  className="bg-ink border border-zinc-700 px-3 py-2.5 text-sm focus:border-volt outline-none [color-scheme:dark]" />
                <select value={form.status} data-testid="pay-status"
                  onChange={(e) => setForm({ ...form, status: e.target.value })}
                  className="bg-ink border border-zinc-700 px-3 py-2.5 text-sm focus:border-volt outline-none">
                  {["paid", "upcoming", "overdue"].map((s) => <option key={s}>{s}</option>)}
                </select>
                <button onClick={() => save(m.user_id)} data-testid="pay-save"
                  className="bg-volt text-black text-xs uppercase tracking-[0.14em] font-extrabold hover:bg-white transition-colors">
                  Save
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="text-xs text-zinc-600 mt-4">Manual tracking for now — the structure is ready for a payment gateway later.</p>
    </div>
  );
}
